import us from './enUS.js'

const currentYear = new Date().getUTCFullYear()

export default {
  ...us,

  Header: {
    ...us.Header,
    titleFormat: (count: number, category: string) => `${count} Best ${category} ${currentYear} in Canada`,
    titleMagaTop: (count: number, category: string) => `Top-${count} ${category}`,
    titleMagaLoved: 'Loved in Canada',
  },
  ProductCard: {
    ...us.ProductCard,
    ctaText: (trafficType?: string, _partnerName?: string) => {
      switch (trafficType) {
        case 'organic-amazon-only':
          return 'More Info'
        case 'paid-long-tail':
          return 'More Info'
        case 'organic-buying-options':
          return 'View Product'
        case 'dws':
          return 'View Deal'
        default:
          return 'View Product'
      }
    },
  },
  Badge: {
    ...us.Badge,
    countryFavorite: "Canada's Favorite",
    countryPick: "Canada's Pick",
    countryTopRated: 'Top Rated in Canada',
    magaBadge: (variation?: string): string => {
      switch (variation) {
        case 'born':
          return 'Born in Canada'
        case 'topBrand':
          return "Canada's Top Brand"
        default:
          return 'Born in Canada'
      }
    },
    discountTextInfo: (variation?: string) => {
      switch (variation) {
        case 'preTariff':
          return 'Selling Fast — Limited Stock'
        case 'solid':
          return 'Smart Buy: Limited-Time Inventory'
        default:
          return 'Selling Fast — Limited Stock'
      }
    },
  },
  ShippingSection: {
    title: "Shipping from Amazon's CA regional warehouses",
  },
} as typeof us
